import React from 'react'

type Props = {
 containerClass?: string
 titleClass?: string
 countClass?: string
 title: string
 count: React.ReactNode
 color: string
}
const KTSummaryCard = (props: Props) => {
 return (
  <>
   <div
    className={`${props?.containerClass} text-[#80868C] relative rounded-lg border-[#E6EBF0] border text-xs font-normal h-[106px] pl-5 pr-2 py-3            
            `}
   >
    <div
     className={`absolute w-2 h-[51px] left-0 top-[25%] rounded-r-lg`}
     style={{backgroundColor: `${props?.color}`}}
    ></div>
    <div
     className={`${props?.countClass} font-bold text-xl text-[#33393D]`}
    >
     {props.count}
    </div>
    <div
     className={`${props?.titleClass}flex font-medium text-base text-[#5A6066]`}
    >
     {props.title}
    </div>
   </div>
  </>
 )
}

KTSummaryCard.defaultProps = {
 className: 'w-full',
}

export {KTSummaryCard}
